import { render } from "./NodeDetailsSimple.vue?vue&type=template&id=3283e349&ts=true"
import script from "./NodeDetailsSimple.vue?vue&type=script&lang=ts"
export * from "./NodeDetailsSimple.vue?vue&type=script&lang=ts"

import "./NodeDetailsSimple.vue?vue&type=style&index=0&id=3283e349&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__